import moment, { Moment } from 'moment';
import { v4 as uuid } from 'uuid';

class CirgsInsurance {
  id: string;

  policyName: string;

  amount: number;

  payAmount: number;

  dateJoined?: Moment;

  validityStartDate?: Moment;

  createdAt?: Date;

  updatedAt?: Date;

  constructor(policyName: string, amount: number, payAmount: number, dateJoined: Moment, validityStartDate: Moment,
    id: string = uuid(), createdAt?: Date, updatedAt?: Date) {
    this.id = id;
    this.policyName = policyName;
    this.amount = amount;
    this.payAmount = payAmount;
    this.dateJoined = dateJoined;
    this.validityStartDate = validityStartDate;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  public objectToBody() {
    return {
      id: this.id,
      policyName: this.policyName,
      amount: this.amount,
      payAmount: this.payAmount,
      dateJoined: this.dateJoined,
      validityStartDate: this.validityStartDate,
    };
  }

  public static jsonToObject(object: any): CirgsInsurance {
    return new CirgsInsurance(
      object.policyName,
      object.amount,
      object.payAmount,
      moment(object.dateJoined, 'YYYY-MM-DD'),
      moment(object.validityStartDate, 'YYYY-MM-DD'),
      object.id,
      object.createdAt,
      object.updatedAt,
    );
  }

  public static getDefault() {
    return CirgsInsurance.jsonToObject({
      policyName: '',
      dateJoined: moment().format('YYYY-MM-DD'),
      validityStartDate: moment().format('YYYY-MM-DD'),
    });
  }
}

export default CirgsInsurance;
